import { ApplicationElement, html } from '@effectivastudio/lit-components';

import '@effectivastudio/lit-components/components/timeago/element.js';
import '../member_menu/element.js';
import '../profile_avatar/element.js';

import translations from './translations.js';
import style from './style.lit.css';

/**
 * Component for showing group/platform members
 *
 * @prop groupRole - Member role (optional)
 * @prop name - Member name
 * @prop uid - User id which is used for ONLINE status (optional)
 * @prop online - ONLY FOR SIMULATION IN STORYBOOK (optional)
 * @prop hideStatus - For showing or hiding online status component (optional)
 * @prop picture - Member profile image url (optional)
 * @prop icon - Override default icon eg. bot users (optional)
 * @prop url - Member profile url (optional)
 *
 * @slot default - Slot for side actions
 * @slot info - Slot for additional info
 *
 * @cssprop --background-color - Element background
 * @cssprop --link-text - Member's name link color
 * @cssprop --padding - Component's padding
 * @cssprop --member-size - Member's avatar size
 * @cssprop --name-weight - Member's name font-weight
 * @cssprop --name-size - Member's name font-size
 */

export default class Member extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    groupRole: { type: String },
    uid: { type: Number },
    name: { type: String },
    online: { type: Boolean },
    hideStatus: { type: Boolean },
    icon: { type: String },
    picture: { type: String },
    url: { type: String },
  };

  /** @internal */
  static translations = translations;

  constructor() {
    super();
    this.icon = 'user';
  }

  renderName() {
    return this.url
      ? html` <h3 class="name"><a href=${this.url}>${this.name}</a></h3>`
      : html`<h3 class="name">${this.name}</h3>`;
  }

  renderGroupRole() {
    return html` <div class="role">${this.t('role')}: ${this.groupRole}</div> `;
  }

  render() {
    return html`
      <xs-profile-avatar
        hideName
        layout="sm"
        .online=${this.online}
        .uid=${this.uid}
        .icon=${this.icon}
        .picture=${this.picture}
        .hideStatus=${this.hideStatus}>
        ${this.name}
      </xs-profile-avatar>

      <div class="info">
        ${this.renderName()} ${this.groupRole ? this.renderGroupRole() : null}
        <slot name="info"></slot>
      </div>
      <div class="actions">
        <slot></slot>
      </div>
    `;
  }
}

Member.registerTagName('xs-member');

customElements.get('xs-member') || customElements.define('xs-member', Member);
